var functions = {
    //时间戳格式化到文本
    dateFormats: function(datetime) {
        if (typeof datetime != 'number' && isNaN(datetime)) {
            return ''
        }
        if (datetime <= 9999999999) {
            datetime = datetime * 1000
        }
        var time = new Date(datetime);
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();


        var s = time.getSeconds();
        return y + '-' + this.getTimeValue(m) + '-' + this.getTimeValue(d) + ' ' + this.getTimeValue(h) + ':' + this.getTimeValue(mm) + ':' + this.getTimeValue(s);
    },
    //日期时间转时间戳
    date2Timestamp: function(date, noTen) {
        const timestamp = (new Date(date)).getTime()
        return !noTen ? parseInt(timestamp / 1000) : timestamp;
    },
    getTimeValue: function(m) {
        return m < 10 ? '0' + m : m
    },
    //检查是否移动设备
    isWap: function() {
        let userAgentInfo = navigator.userAgent.toLowerCase();
        let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        let flag = false;
        for (let v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v].toLowerCase()) >= 0) {
                flag = true;
                break;
            }
        }
        return flag;
    },
    //浮点数值格式化 解决精度问题
    floatFormat: function(value, len) {
        len = len ? len : 2
        if (typeof value != 'number') {
            return 0
        }
        return value.toFixed(len)
    },
    //url完整解析
    parseUrl(url) {
        if (typeof url != 'string') {
            return '';
        }
        if (url.indexOf('http') < 0 && url.substring(0, 2) != '//') {
            url = window.API_URL + url;
        }
        return url;
    },
    //文件大小格式化
    formatFileSize(value) {
        if (null == value || value == '') {
            return "0 Bytes";
        }
        var unitArr = new Array("Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB");
        var index = 0;
        var srcsize = parseFloat(value);
        index = Math.floor(Math.log(srcsize) / Math.log(1024));
        var size = srcsize / Math.pow(1024, index);
        size = size.toFixed(2); //保留的小数位数
        return size + unitArr[index];
    },
    //对象或数组完美深度克隆，但不影响旧数据 
    //注：由于vue直接用=或传值时用=都是指向的同一个内存地址 所以不能用=
    objectCopy($vars) {
        if (typeof $vars == 'object') {
            return JSON.parse(JSON.stringify($vars))
        }
        return {}
    }
}

export default functions


// WEBPACK FOOTER //
// ./src/function/global.js